import { Box, Card, CardHeader, CardBody, Heading, Text } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { UserForm } from '@/components/forms/UserForm'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function CreateUserPage() {
  const colors = useThemeColors()
  const navigate = useNavigate()

  const handleSuccess = () => {
    navigate('/user-management/users')
  }

  const handleCancel = () => {
    navigate('/user-management/users')
  }

  return (
    <AdminLayout>
      <Box p={4} h="100%" overflow="auto">
        <Card>
          <CardHeader>
            <Heading size="md" mb={1}>
              Create User
            </Heading>
            <Text fontSize="sm" color={colors.text}>
              Add a new user account with role assignments
            </Text>
          </CardHeader>
          <CardBody>
            <UserForm onSuccess={handleSuccess} onCancel={handleCancel} />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}


